import { type PartnerFlow, PartnerFlowValues } from "@remi/enums/partner-flow";
import { PartnerFlowToBuyerOrganizationId } from "@remi/types/source";

import { hasCapability, type User } from "../base";

export const partnerFlow = {
  view: (_user: User, _partnerFlow: PartnerFlow): boolean => {
    return true;
  },
  read: (user: User): boolean => hasCapability(user, "partnerFlow.read"),
  viewable: (_user: User): PartnerFlow[] => {
    return [...PartnerFlowValues];
  },
  config: {
    read: (user: User, partnerFlow: PartnerFlow): boolean => {
      if (hasCapability(user, "partnerFlow.config.read")) {
        return true;
      }
      return PartnerFlowToBuyerOrganizationId[partnerFlow].some((buyerOrganizationId) => {
        return buyerOrganizationId === user.person.organizationId;
      });
    },
  },
};
